import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "slide", "dot"]

  static values = {
    currentIndex: { type: Number, default: 0 },
    inputName: { type: String, default: null },
  }

  // Mobile swipes functionality

  touchStart(e) {
    this.startX = e.touches[0].clientX
  }

  touchEnd(e) {
    if (this.startX === undefined) return

    const endX = e.changedTouches[0].clientX
    const diff = this.startX - endX
    const threshold = 40

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.nextSlide()
      } else {
        this.prevSlide()
      }
    }

    this.startX = undefined
  }

  nextSlide() {
    this.currentIndexValue = (this.currentIndexValue + 1) % this.slideTargets.length
  }

  prevSlide() {
    this.currentIndexValue = this.currentIndexValue === 0 ? this.slideTargets.length - 1 : this.currentIndexValue - 1
  }

  // Base functionality

  currentIndexValueChanged() {
    this.updateSlides()
    this.updateDots()
    this.updateInputValue()
  }

  updateInputValue() {
    if (!this.inputNameValue) return

    const formInput =
      document.querySelector(`input[name="${this.inputNameValue}"]`) ||
      document.querySelector(`select[name="${this.inputNameValue}"]`)

    formInput.value = this.slideTargets[this.currentIndexValue].dataset.value
  }

  changeSlide(event) {
    this.currentIndexValue = Array.from(this.dotTargets).indexOf(event.currentTarget)
  }

  updateSlides() {
    this.slideTargets.forEach((slide, index) => {
      if (index === this.currentIndexValue) {
        slide.classList.remove("opacity-0")
        slide.classList.add("opacity-100")
      } else {
        slide.classList.remove("opacity-100")
        slide.classList.add("opacity-0")
      }
    })
  }

  updateDots() {
    this.dotTargets.forEach((dot, index) => {
      dot.classList.toggle("bg-zinc-950", index === this.currentIndexValue)
      dot.classList.toggle("bg-gray-100", index !== this.currentIndexValue)
    })
  }

  transitionEnd(event) {
    event.currentTarget.classList.add("hidden")

    const activeSlide = this.slideTargets[this.currentIndexValue]
    activeSlide.classList.remove("hidden")
    activeSlide.classList.remove("opacity-0")
  }
}
